import JSZip from 'jszip';
import { ElectronApi } from './electron.api';
import { dirToMd5 } from '@/utils/md5.utils';
import { ensureDir, testAccess } from '@/utils/fs/fs-extra.utils';
import { zipDir } from '@/utils/fs/zip.utils';
import { WatchfaceService } from './watchface';
import { validWatchfaceDir } from '@/utils/watchface-valid.utils';

export interface WatchfaceSample {
  name: string;
  deviceType: string;
  size: string;
  zip: string;
}

/**
 * 表盘样例
 */
export class SampleService {
  private url =
    'https://watchface-editor-release.cnbj1.mi-fds.com/watchface-editor-release/templates';
  private jsonFilename = 'watchface.samples.json';

  async getSamples() {
    try {
      const url = this.url + '/' + this.jsonFilename + '?_key=' + Math.random();
      const data: WatchfaceSample[] = await fetch(url).then((r) => r.json());
      data.sort(function (a, b) {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
      return data;
    } catch (error) {
      console.log(error);
    }
  }

  /**
   *
   * @param zip
   * @param saveDir
   */
  async downloadSampleZip(zipfile: string) {
    try {
      const path = ElectronApi.path;
      const fs = ElectronApi.fs;
      if (!fs || !path) return;
      // 模版样例保存目录
      const samplesDir = path.join(
        (await ElectronApi.getPath('userData')) ?? '',
        'Samples'
      );

      const url = this.url + '/' + zipfile + '?_key=' + Math.random();

      // 模版目录
      const sampleDir = path.join(samplesDir, zipfile.replace('.zip', ''));
      let valid = true;
      try {
        valid = await validWatchfaceDir(sampleDir);
      } catch (error) {
        valid = false;
      }
      if ((await testAccess(sampleDir)) && valid) return sampleDir;

      await ensureDir(sampleDir);
      // 下载模版
      const fileBf = await fetch(url).then((r) => r.arrayBuffer());
      const zip = await JSZip.loadAsync(fileBf);
      for (const item of Object.entries(zip.files)) {
        const [file, fileObj] = item;
        if (fileObj.dir) continue;
        const content = await fileObj.async('arraybuffer');
        const filename = path.join(sampleDir, file);
        await ensureDir(path.dirname(filename));
        await fs.promises.writeFile(filename, Buffer.from(content));
      }
      return sampleDir;
    } catch (error) {
      console.log(error);
    }
  }

  async exportSample(watchfacePath: string) {
    const path = ElectronApi.path;
    const fs = ElectronApi.fs;
    if (!fs || !path) return;

    const service = new WatchfaceService(watchfacePath);
    const desc = await service.description.getDescriptionData();
    const buffer = (await zipDir(watchfacePath)) as ArrayBuffer;
    if (!buffer || !desc) return;
    // const zipfile = textToMd5(buffer, true) + '.zip';
    const appDir = (await ElectronApi.getAppInfo()).appPath;
    const samplesDir = path.join(appDir, 'samples');

    const zipFile = (await dirToMd5(watchfacePath, true)) + '.zip';

    const _zipfile = path.join(samplesDir, zipFile);
    await fs.promises.writeFile(_zipfile, Buffer.from(buffer));

    const jsonfile = path.join(samplesDir, 'watchface.samples.json');
    const json = (await testAccess(jsonfile))
      ? ((await fs.promises
          .readFile(jsonfile, 'utf8')
          .then((r) => JSON.parse(r))) as WatchfaceSample[])
      : [];

    const item = json.find((item) => item.zip == zipFile);
    const attrs = {
      name: desc.name,
      deviceType: desc.deviceType ?? '',
      size: desc.size
    };
    if (item) {
      Object.assign(item, attrs);
    } else {
      json.push({
        zip: zipFile,
        ...attrs
      });
    }
    await fs.promises.writeFile(jsonfile, JSON.stringify(json, undefined, 2));
    return _zipfile;
  }
}
